import Link from 'next/link';
import { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import AOS from 'aos';
import { Form, message } from 'antd';
import useTrans from '../../hooks/useTrans';
import MetaSeo from '../MetaSeo';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { getListProjectWeb } from '../../redux/actions/project';
import _ from 'lodash';
import router from 'next/router';

export default function Project(props) {
  useEffect(() => {
    // if (props.match.params.id) {
    //     getDetail(props.match.params.id);
    // }
    setRows(props.rows);
    setTotal(props.total);
    setPage(props.page);
    setDataField(props.data_field.data);
    setDataLanguage(props.data_language.data);
  }, [props]);
  const [rows, setRows] = useState(props.rows || []);
  const [total, setTotal] = useState(props.total || null);
  const [page, setPage] = useState(props.page || 1);
  const [limit, setLimit] = useState(props.limit || 10);
  const [search, setSearch] = useState(null);
  const [is_search, setIsSearch] = useState(false);
  const dispatch = useDispatch();
  const trans = useTrans();
  const [data_field, setDataField] = useState(props.data_field.data || []);
  const [data_language, setDataLanguage] = useState(
    props.data_language.data || [],
  );
  const [array_tag_id, setArrayTagId] = useState([]);
  const filterTag = async tag_id => {
    if (array_tag_id.length && array_tag_id.includes(tag_id)) {
      let tag_array = array_tag_id.filter(it => it !== tag_id);
      setArrayTagId(tag_array);
      const data = await getListProjectWeb(
        { tag_id: tag_array, name: search?.trim() },
        dispatch,
      );
      if (data) {
        setRows(data.rows);
        setTotal(data.total);
        setPage(data.page);
      }
    } else {
      let tag_array = [...array_tag_id];
      tag_array.push(tag_id);
      setArrayTagId(tag_array);
      const data = await getListProjectWeb(
        { tag_id: tag_array, name: search?.trim() },
        dispatch,
      );
      if (data) {
        setRows(data.rows);
        setTotal(data.total);
        setPage(data.page);
      }
    }
  };
  const filterOneTag = async tag_id => {
    let tag_array = [];
    tag_array.push(tag_id);
    const data = await getListProjectWeb(
      { tag_id: tag_array, name: search },
      dispatch,
    );
    if (data) {
      setRows(data.rows);
      setTotal(data.total);
      setPage(data.page);
    }
  };
  const loadMore = async () => {
    let new_page = parseInt(page) + 1;
    setPage(new_page);
    const data = await getListProjectWeb(
      { page: new_page, limit, tag_id: array_tag_id },
      dispatch,
    );
    if (data) {
      const new_data = [...rows, ...data.rows];
      setRows(new_data);
    }
  };
  const onSearch = async () => {
    let data = await getListProjectWeb(
      { page: 1, limit, name: search.trim(), tag_id: array_tag_id },
      dispatch,
    );
    setIsSearch(true);
    if (data) {
      setRows(data.rows);
      setTotal(data.total);
    }
  };
  const onSearchDelay = _.debounce(() => onSearch(), 100);
  const onEnterkey = e => {
    if (e.key === 'Enter') {
      onSearch();
    }
  };
  const dataSeo = {
    title: 'Dự án | TCOM Corporation',
    description:
      'TCOM đã triển khai nhiều dự án lớn, ở hầu hết các lĩnh vực, làm khách hàng trong và ngoài nước hài lòng.',
  };
  const dataSeoEN = {
    title: 'Outstanding Projects | TCOM Corporation',
    description: 'Our noteworthy projects to the delight of our clients',
  };
  return (
    <>
      {trans.seoVN ? <MetaSeo {...dataSeo} /> : <MetaSeo {...dataSeoEN} />}

      <div className='main-content'>
        <div className='r-top'>
          <div className='container'>
            <div className='row'>
              <div className='col-12 col-md-6'>
                <div className='title-left'>
                  <h3>{trans.project.feature_project}</h3>
                  <p className='desc'>
                    {trans.project.project_sub1}
                    <br /> {trans.project.project_sub2}
                  </p>
                </div>
              </div>
              <div className='col-12 col-md-6'>
                <div className='search'>
                  <input
                    onChange={e => setSearch(e.target.value)}
                    value={search}
                    type='text'
                    placeholder={trans.seoVN ? 'Tìm kiếm' : 'Search'}
                    onKeyDown={onEnterkey}
                  />
                  <button onClick={onSearchDelay}>
                    <svg
                      width={24}
                      height={24}
                      viewBox='0 0 24 24'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M21 21L16.514 16.506L21 21ZM19 10.5C19 12.7543 18.1045 14.9163 16.5104 16.5104C14.9163 18.1045 12.7543 19 10.5 19C8.24566 19 6.08365 18.1045 4.48959 16.5104C2.89553 14.9163 2 12.7543 2 10.5C2 8.24566 2.89553 6.08365 4.48959 4.48959C6.08365 2.89553 8.24566 2 10.5 2C12.7543 2 14.9163 2.89553 16.5104 4.48959C18.1045 6.08365 19 8.24566 19 10.5V10.5Z'
                        stroke='#A7A7A7'
                        strokeWidth={2}
                        strokeLinecap='round'
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {rows.length ? (
          <div className='r-project-list'>
            <div className='container'>
              <div className='row'>
                {rows.map(item => {
                  return (
                    <div className='col-12 col-md-6 col-xl-6'>
                      <Link href={`/${props.sign}/project/${item.seo_url}`}>
                        <a className='image'>
                          <img src={item.background_image} alt={item.description} />
                        </a>
                      </Link>
                      <div className='content'>
                        <Link href={`/${props.sign}/project/${item.seo_url}`}>
                          <a className='title'>{item.name}</a>
                        </Link>
                        <ul className='tag'>
                          {item.project_hook_tag.map(it => {
                            return (
                              <li>
                                <a>{it?.project_tag?.name}</a>
                              </li>
                            );
                          })}
                        </ul>
                        <p className='desc' title={item.description}>
                          {item.description}
                        </p>
                        <Link href={`/${props.sign}/project/${item.seo_url}`}>
                          <a className='readmore'>
                            {trans.text_button.read_more}
                            <svg
                              width={20}
                              height={20}
                              viewBox='0 0 20 20'
                              fill='none'
                              xmlns='http://www.w3.org/2000/svg'
                            >
                              <path
                                fillRule='evenodd'
                                clipRule='evenodd'
                                d='M1.25 10.0008C1.25 9.83503 1.31585 9.67606 1.43306 9.55885C1.55027 9.44164 1.70924 9.37579 1.875 9.37579H16.6163L12.6825 5.44329C12.5651 5.32593 12.4992 5.16676 12.4992 5.00079C12.4992 4.83482 12.5651 4.67565 12.6825 4.55829C12.7999 4.44093 12.959 4.375 13.125 4.375C13.291 4.375 13.4501 4.44093 13.5675 4.55829L18.5675 9.55829C18.6257 9.61635 18.6719 9.68532 18.7034 9.76125C18.7349 9.83718 18.7511 9.91858 18.7511 10.0008C18.7511 10.083 18.7349 10.1644 18.7034 10.2403C18.6719 10.3163 18.6257 10.3852 18.5675 10.4433L13.5675 15.4433C13.4501 15.5606 13.291 15.6266 13.125 15.6266C12.959 15.6266 12.7999 15.5606 12.6825 15.4433C12.5651 15.3259 12.4992 15.1668 12.4992 15.0008C12.4992 14.8348 12.5651 14.6756 12.6825 14.5583L16.6163 10.6258H1.875C1.70924 10.6258 1.55027 10.5599 1.43306 10.4427C1.31585 10.3255 1.25 10.1666 1.25 10.0008Z'
                                fill='#0063AA'
                              />
                            </svg>
                          </a>
                        </Link>
                      </div>
                    </div>
                  );
                })}

                {rows.length < total && (
                  <div className='col-12 text-center'>
                    <a onClick={() => loadMore()} className='see-more'>
                      {trans.project.load_more}
                    </a>
                  </div>
                )}
              </div>
            </div>
          </div>
        ) : (
          <div id='not-found'>
            <div className='main-content'>
              <div className='container'>
                <div className='inner'>
                  <div className='image'>
                    <img src='/assets/images/404-search.png' alt='' />
                  </div>
                  <h3>{trans.project.no_result}</h3>
                  <a href='/' className='btn-back'>
                    {trans.project.back_home}
                  </a>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
